module.exports = __webpack_public_path__ + "static/media/StandingBits.a743abb5.gif";